{
  "steplist": "Списък със стъпки"
}
